// biome-ignore lint/style/noRestrictedImports: legacy import pattern
import { PrimaryButton } from '@crehana/ui';

import { Link } from '@/shared/components/react-router-dom';

const examplePages = [
  { name: 'Classroom (player)', urls: ['/clases/v2/11805/player/45955/'] },
];

export const Home = () => {
  return (
    <div className="tw-w-screen tw-h-screen tw-overflow-hidden tw-flex tw-items-center tw-justify-center">
      <div className="tw-p-4">
        <h1 className="tw-font-body5">
          Welcome to the Crehana microfrontend! 😊
        </h1>
        <p className="tw-my-0.8">
          There are a few example urls that this MF contains
        </p>
        <ul className="tw-list-disc tw-list-inside">
          {examplePages.map(page => (
            <li
              key={page.name}
              className="tw-list-disc tw-list-inside tw-my-1.2"
            >
              <span className="tw-mb-0.8 tw-inline-block">{page.name}</span>
              <ul className="tw-list-inside tw-pl-2.4">
                {page.urls.map(url => (
                  <li
                    key={url}
                    className="tw-list-disc tw-list-inside tw-mb-0.8 tw-font-link2 tw-text-primary-light-400"
                  >
                    <Link to={url}>{url}</Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <div className="tw-mt-2.4">
          <h2 className="tw-font-h5 tw-font-semibold tw-mb-1.2">
            Sentry testing
          </h2>
          <PrimaryButton
            label="Throw an error"
            size="xs"
            onClick={() => {
              const error = `${new Date().toISOString()}- Sentry frontend error example`;
              throw new Error(error);
            }}
          />
        </div>
      </div>
    </div>
  );
};
